import React from "react";
import { motion } from "framer-motion";
import { Quote } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";
import { TESTIMONIALS } from "../data/content";

export const Testimonials = () => {
  const { t } = useLang();
  return (
    <section id="testimonials" className="relative py-24 lg:py-32 bg-[#08080A] border-y border-white/10" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="max-w-3xl mb-14">
          <div className="text-xs tracking-[0.2em] uppercase font-mono text-cyan mb-4">{t("testimonials_eyebrow")}</div>
          <h2 className="font-head font-bold text-3xl sm:text-4xl lg:text-5xl tracking-tight text-white">{t("testimonials_title")}</h2>
          <p className="mt-5 text-base text-zinc-400 leading-relaxed">{t("testimonials_subtitle")}</p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
          {TESTIMONIALS.map((tst, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              className={`card-glow rounded-2xl p-8 flex flex-col justify-between ${tst.span}`}
              data-testid={`testimonial-card-${i}`}
            >
              <Quote size={28} className="text-cyan mb-5" />
              <p className="font-head text-xl sm:text-2xl leading-snug text-white mb-6">"{tst.quote}"</p>
              <div>
                <div className="text-sm font-semibold text-white">{tst.author}</div>
                <div className="text-xs font-mono text-zinc-500 mt-0.5">{tst.org}</div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
